<template>
  <div class="Links">
    <svg-icon icon-class="link" class="icon-link"></svg-icon>
    <span>友情链接</span>
    <ul class="LinksList">
      <li v-for="(item1, index) in LinksList" :key="index">
        <el-select
          ref="select"
          v-model="item1.friendshipAddressName"
          placeholder="请选择"
          @focus="getItem(item1)"
        >
          <el-option
            v-for="item in item1.options"
            :key="item.friendshipAddressItemId"
            :label="item.friendshipAddressItemName"
            :value="item.friendshipAddressItemUrl"
            @click.native="change(item)"
          >
          </el-option>
        </el-select>
      </li>
    </ul>
  </div>
</template>
<script>
import {
  queryFriendshipAddressPage,
  queryFriendshipAddressItemPage
} from "@/app/shop/api/shopping";
export default {
  name: "Links",
  data() {
    return {
      LinksList: [],
      options: [],
      value: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      queryFriendshipAddressPage({}).then(res => {
        if (res.data.code === "0") {
          this.LinksList = res.data.data.rows.map(item => {
            item.options = [];
            return item;
          });
        }
      });
    },
    getItem(item) {
      queryFriendshipAddressItemPage({
        friendshipAddressId: item.friendshipAddressId
      }).then(res => {
        if (res.data.code === "0") {
          item.options = res.data.data.rows;
        }
      });
    },
    change(data) {
      window.open(data.friendshipAddressItemUrl, "_blank");
    }
  }
};
</script>
<style scoped lang="scss">
.Links {
  margin-top: 20px;
  padding-top: 20px;
  background: linear-gradient(180deg, #f8fcff 0%, #ffffff 100%);
  border-top: 1px solid #0089ef;
  span {
    font-size: 24px;
    color: #4a4a4a;
    line-height: 30px;
    font-weight: 500;
  }
  .LinksList {
    display: flex;
    /*justify-content: space-between;*/
    padding: 0 0 40px 20px;
    flex-wrap: wrap;
    li {
      margin-right: 20px;
      height: 30px;
      margin-top: 20px;
    }
    .el-select {
      width: 212px;
    }
  }
}
.icon-link {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  margin-left: 20px;
}
</style>
